import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { RoutePaths } from '../../core/constants/route-paths';
import { ModalService } from '../shared/services/modal.service';
import { DataLayerService } from '../../core/services/data-layer.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
  providers: [],
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  currentYear: string = '';

  constructor(
    private readonly _router: Router,
    private readonly _modalService: ModalService,
    private readonly _dataLayerService: DataLayerService
  ) {}

  ngOnInit() {
    let date = new Date();
    this.currentYear = date.getFullYear().toString();
  }

  async openCookiesPage(): Promise<void> {
    this._dataLayerService.pushEventClickLink(
      '',
      'cookies-page',
      'footer.cookies',
      'footer'
    );
    await this._router.navigate([`${RoutePaths.cookiesPage}`]);
  }

  async openModal() {
    this._dataLayerService.pushEventClickLink(
      '',
      'policy-cookie',
      'footer.privacity',
      'footer'
    );
    this._modalService.openPolicityCookieModal();
  }

  oneTrustEvent(): void {
    this._dataLayerService.pushEventClickLink(
      '',
      'one-trust-cookie-settings',
      'cookies config',
      'footer'
    );
  }
}
